import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    root: {
      // flexDirection: 'row',
      height: 50,
      paddingLeft: 15,
      // alignItems: 'center',
      // justifyContent: 'space-between',
    },
    linkLightHover: {
      ':hover': {
        backgroundColor: theme.palette.neutralLighter,
      },
    },
    headerCell: {
      // flex: 1,
      width: '100%',
      paddingLeft: 15,
      height: 50,
    },
    descriptionCell: {
      paddingLeft: 68,
    },
    actionHeaderCell: {
      flex: 1,
      paddingLeft: 25,
      height: 50,
    },
    actionColumnWidth: {
      paddingLeft: 10,
      width: 370,
      minWidth: 370,
      maxWidth: 370,
      // border: "1px solid yellow",
    },
    regularColumnWidth: {
      width: 140,
      minWidth: 140,
      maxWidth: 140,
      // border: "1px solid green",
      paddingLeft: 10,
    },
  };
});
